
(function ($) {

  'use strict';

  /** CLICK ELEMENTS **/

  /** DOM ELEMENTS **/
  var $body = $('body');

  /** JQUERY CLASS AND SELECTOR STRINGS **/
  var classEmbedOverlay = 'embed-scroll-zoom-disable';
  var selectorEmbedMap = '.embed-map';
  var selectorEmbedMapIframe = selectorEmbedMap + ' iframe';
  var selectorEmbedOverlay = selectorEmbedMap + ' .' + classEmbedOverlay;

  /** CLICK EVENTS **/

  /** FUNCTIONS **/
  function fireRellax() {
    /* eslint-disable */
    // Disable for usage of Rellax library.
    var rellax;
    if (window.matchMedia('(min-width: 769px)').matches) {
      rellax = new Rellax('.rellax');
    }
    /* eslint-enable */
  }

  /** Document Ready **/

  $(document).ready(function () {

    // Run parallax animations
    if ($('.rellax').length) {
      fireRellax();
    }

    // For Content-type: experience / View-mode: full
    if ($body.hasClass('page-node-type-experience')) {
      // Disable scroll-to-zoom on iframe map.
      if ($(selectorEmbedMap).length > 0) {
        $(selectorEmbedMap).prepend('<div class="' + classEmbedOverlay + '"></div>');
        $(selectorEmbedMapIframe).on('mouseleave', function () { $(selectorEmbedOverlay).show(); });
        $(selectorEmbedOverlay).on('mousedown', function () { $(this).hide(); });
      }
    }

  });

  /** Window Scroll **/
  $(window).scroll(function () {
    if ($body.hasClass('page-node-type-experience')) {
      // Only run if embed exists.
      if ($(selectorEmbedMap).length > 0) {
        $(selectorEmbedOverlay).show();
      }
    }
  });

})(jQuery);

// # sourceMappingURL=maps/experiences.js.map
